import { Directive, EventEmitter, Injectable, Input, Output, ViewChild, } from '@angular/core';
import { TemplateUuids } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
export class ToggleableInputDirective {
    _changeDetectorRef;
    _inputElement;
    _checked = false;
    get checked() {
        return this._checked;
    }
    set checked(value) {
        this._checked = value;
        this._inputElement.nativeElement.checked = value;
        this._changeDetectorRef.markForCheck();
    }
    _disabled = false;
    templateUuids = new TemplateUuids();
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = !!value;
    }
    _indeterminate = false;
    get indeterminate() {
        return this._indeterminate;
    }
    set indeterminate(value) {
        this._indeterminate = value ? true : false;
        this._inputElement.nativeElement.indeterminate = this._indeterminate;
        this._changeDetectorRef.markForCheck();
    }
    _value = null;
    get value() {
        return this._value;
    }
    set value(value) {
        if (this.value !== value) {
            this._value = value;
        }
    }
    // eslint-disable-next-line @angular-eslint/no-output-native
    change = new EventEmitter();
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
    }
    _onChangeEvent(event) {
        event.stopPropagation();
        this.checked = this._inputElement.nativeElement.checked;
        this.change.emit(this.checked);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChangeCallback = (_) => { };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onTouchedCallback = () => { };
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this._changeDetectorRef.markForCheck();
    }
    writeValue(val) {
        if (val !== this.value) {
            this.value = val;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleableInputDirective, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.4.0", type: ToggleableInputDirective, inputs: { checked: "checked", disabled: "disabled", indeterminate: "indeterminate", value: "value" }, outputs: { change: "change" }, viewQueries: [{ propertyName: "_inputElement", first: true, predicate: ["input"], descendants: true, static: true }], ngImport: i0 });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleableInputDirective });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleableInputDirective, decorators: [{
            type: Directive
        }, {
            type: Injectable
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { _inputElement: [{
                type: ViewChild,
                args: ['input', { static: true }]
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], indeterminate: [{
                type: Input
            }], value: [{
                type: Input
            }], change: [{
                type: Output
            }] } });
